import "./App.css";
import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";
import Home from "./pages/home/Home";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import UserList from "./pages/userList/UserList";
import User from "./pages/user/User";
import NewUser from "./pages/newUser/NewUser";
import ProductList from './pages/productList/ProductList'
import Product from "./pages/product/Product";
function App() {
  return (
    <Router>
      <Topbar />
      <div className="container">
        <Sidebar />

        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/user" element={<UserList />} />
          <Route exact path="/user/:userId" element={<User />} />
          <Route exact path="/new_user" element={<NewUser />} />
          <Route exact path="/new_user" element={<NewUser />} />
          <Route exact path="/product" element={<ProductList />} />
          <Route exact path="/product/:productId" element={<Product />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
